import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { fetchAcademicYearsOfSchool } from "./counterApi";
import toast from "react-hot-toast";

const initialState = {
  academicYearData: [],
  globalAcedemicYearId: null,
  value: 0,
  fetchLoading: false,
  loading: false,
  error: null,
};

// export const fetchAcademicYearsAsync = createAsyncThunk(
//   "academicYear/fetchAcademicYears",
//   async (schoolId) => {
//     return await fetchAcademicYearsOfSchool(schoolId);
//   }
// );

const counterSlice = createSlice({
  name: "counterSlice",
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

export const { increment, decrement, incrementByAmount } = counterSlice.actions;
export default counterSlice.reducer;
